/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { Fragment, useEffect, useMemo } from 'react';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { makeStyles } from '@material-ui/core/styles';
import Loading from 'aurora-components/Loading';
import { FormattedMessage } from 'react-intl';
import messages from 'aurora-translations';
import history from 'aurora-utils/history';
import error, { errorProps } from 'aurora-utils/error';
import { login } from 'aurora-composition/modules/authentication/actions/login';
import { logout } from 'aurora-composition/modules/authentication/actions/logout';
import { ADGMImage } from 'aurora-components';
import { ACTIVE_URL_UAE_PASS } from 'aurora-utils/constants';
import { persistStore } from 'aurora-composition/actions/auroraUiActions';
import { useLocation } from 'react-router-dom';

// import { CleverTapHeaderLanguageSwitch } from 'aurora-utils/cleverTap.eventhelper';
import ErrorScreen from './Error';
const useStyles = makeStyles(theme => ({
  btn: {
    marginBottom: '16px',
    width: '100%',
    padding: '14px 22px',
    fontSize: '1rem',
    borderRadius: '0px',
    textTransform: 'none',
    border: '1px solid  #130F26',
    background: '#fff',
    cursor: 'pointer',
    fontWeight: '500',
    color: '#130F26',
    '&:hover': {
      textDecoration: 'none',
      background: '#EBEEF3',
    },
    '& svg,img': {
      marginInlineEnd: theme.spacing(1),
    },
    '@media (max-width: 600px)': {
      padding: '13px 22px',
    },
  },
  BtnSIGN_UAE: {
    background: '#fff',
    color: '#000',
    border: '1px solid #000',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  title: {
    fontWeight: '500',
    margin: '0px 24px',
    color: '#130F26',
    fontSize: '24px',
    textAlign: 'center',
  },
  subTitle: {
    textAlign: 'center',
  },
  textPrimary: {
    color: theme.palette.primary.main,
  },
  textGreen: {
    color: theme.palette.primary.adgmGreen,
  },
  btnLink: {
    width: '100%',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'none',
    },
    '& button': {
      color: theme.palette.primary.white,
      background: theme.palette.primary.main,
      border: 'none',
      '&:hover': {
        background: theme.palette.primary.adgmHover,
      },
    },
  },
  uaePassButton: {
    width: '330px',
    '&>img': {
      width: '100%',
    },
  },
  linkButton: {
    fontWeight: 500,
    padding: '0px',
    '&:hover': {
      background: 'none',
    },
    textTransform: 'none',
  },
  hrLine: {
    position: 'relative',
    fontSize: '14px',
    textAlign: 'center',
    color: '#130F26',
    margin: '20px 0px 30px',
    '&:before, &:after': {
      position: 'absolute',
      top: '50%',
      width: '44%',
      height: '1px',
      content: "''",
      backgroundColor: '#CED1D6',
      left: '0px',
    },
    '&:after': {
      right: '0px',
      left: 'inherit',
    },
  },
  registerNow: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
  },
  bottomtextholder: {
    marginTop: '24px',
    textAlign: 'center',
    color: '#0088FF',
    '& $linkGuest': {
      fontSize: '16px',
      color: '#0088FF',
      fontWeight: '400',
      cursor: 'pointer',
      marginTop: '15px',
      display: 'flex',
      justifyContent: 'center',
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'none',
      },
    },
    '& $iconsButton': {
      fontSize: '14px',
      color: '#484456',
      fontWeight: '400',
      cursor: 'pointer',
      marginTop: '15px',
      display: 'flex',
      justifyContent: 'center',
      textDecoration: 'none',
      fontFamily: 'madani, sans-serif!important',
      lineHeight: '18px',
      alignItems: 'flex-start',
      '&:hover': {
        textDecoration: 'none',
      },
      '& img': {
        marginLeft: '6px',
        width: '14px',
      },
    },
  },
  helpLink: {
    display: 'block',
    textAlign: 'center',
    color: '#0088FF',
    fontSize: '16px',
    fontWeight: '500',
  },
  iconsButton: {},
  linkGuest: {},
  uaePassBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  margin24px: {
    margin: '32px',
    textAlign: 'center',
  },
  orDivider: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '10px  ',
    marginBottom: '10px  ',
    width: '100%',
  },
  //      divider:{
  // width:'40%'
  //      },

  or: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '400',
    width: '20%',
  },
}));
function AuthSelector(props) {
  const location = useLocation();

  const {
    title,
    subTitle,
    subTitleLink,
    subTitleLinkText,
    redirectEID,
    redirectUnified,
    redirectNonUAE,
    handleLogin,
    loading,
    failure,
    handleLogout,
    showEid = false,
    location: { search = null },
  } = props;

  // /---------------------------------- uae pass only
  const token = new URLSearchParams(search).get('code');
  const { BASE_URL_UAE_PASS } = ACTIVE_URL_UAE_PASS;
  const isProduction = useMemo(() => {
    return process.env.REACT_APP_ACTIVE_WEB_URL === 'https://accessrp.adgm.com';
  }, []);
  let uaePassErrorDescription = '';
  if (!token) {
    const errorDescriptionFromApi = new URLSearchParams(search).get('error_description');
    console.log(errorDescriptionFromApi);
    const errorDescriptionMsgList = [
      'Cancelled by user on UAE PASS app.',
      'Cancelled by user on UAE PASS web.',
      'Timeout on WebWaiting',
    ];
    uaePassErrorDescription =
      errorDescriptionMsgList.indexOf(errorDescriptionFromApi) !== -1 ? errorDescriptionFromApi : null;
    // : 'uae_pass_login_exception';
  }
  console.log(uaePassErrorDescription);
  useEffect(() => {
    if (token) {
      handleLogin(token, 'password', 'uaePass'); // eslint-disable-line
    }
  }, [token]);

  const logOutWithUAEPass = sop1Error => {
    if (sop1Error) {
      handleLogout(sop1Error);
    }
  };

  // -----------------uae pass only-----------
  const classes = useStyles();

  const loginWithGuest = () => {
    localStorage.removeItem('uae_pass_error');
    handleLogin('', '', 'GuestLogin');
  };

  const loginWithUAEPass = () => {
    localStorage.removeItem('uae_pass_errorCode');
    localStorage.removeItem('uae_pass_error');
    localStorage.removeItem('uae_pass_errorCode_count');
    const vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
      vars[key] = value;
    });
    // localStorage.setItem('redirect_url', vars.next);
    window.open(`${BASE_URL_UAE_PASS}=${localStorage.getItem('lang')}`, '_self');
  };

  // no required
  const authRedirection = url => {
    localStorage.removeItem('uae_pass_error');

    const vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
      vars[key] = value;
    });
    // localStorage.setItem('redirect_url', vars.next);
    history.push(url);
  };
  const { locale } = useSelector(state => state.language);
  const handleLocalToggle = () => {
    if (locale === 'ar') {
      persistStore('en');
      // CleverTapHeaderLanguageSwitch('en');
    } else {
      persistStore('ar');
      // CleverTapHeaderLanguageSwitch('ar');
    }
  };
  const showErrorScreen = useMemo(() => {
    return failure?.message || uaePassErrorDescription;
  }, [failure, uaePassErrorDescription]);

  return (
    <Fragment>
      {loading && <Loading />}
      {showErrorScreen || localStorage.getItem('uae_pass_errorCode') ? (
        <div>
          <ErrorScreen
            errorCode={failure?.data?.statusCode}
            errorDescription={failure?.data?.description}
            uaePassErrorDescription={uaePassErrorDescription}
            logOutWithUAEPass={logOutWithUAEPass}
          />
        </div>
      ) : (
        <>
          <Typography variant='h5' component='h2' className={classes.title}>
            {title}
          </Typography>
          <p className={classes.subTitle}>
            {subTitle}
            <Link href={subTitleLink} className={classes.textPrimary}>
              {subTitleLinkText}
            </Link>
          </p>
        </>
      )}
      <div
        className={classNames([
          classes.uaePassBox,
          showErrorScreen || localStorage.getItem('uae_pass_errorCode') ? {} : classes.margin24px,
        ])}
      >
        {showEid === true && (
          <>
            <Link
              className={classes.btnLink}
              onClick={() => {
                authRedirection(redirectEID);
              }}
            >
              <Button className={classes.btn} size='large' fullwidth>
                <FormattedMessage {...messages.sign_with_eid_number} />
              </Button>
            </Link>
            <Link
              className={classes.btnLink}
              onClick={() => {
                authRedirection(redirectUnified);
              }}
            >
              <Button className={classes.btn} type='button' size='large' fullwidth>
                <FormattedMessage {...messages.sign_with_unified_number} />
              </Button>
            </Link>

            <Link
              className={classes.btnLink}
              onClick={() => {
                authRedirection(redirectNonUAE);
              }}
            >
              <Button className={classes.btn} type='button' size='large' fullwidth>
                <FormattedMessage {...messages.non_UAE_resident_login} />
              </Button>
            </Link>
          </>
        )}
        {showEid && (
          <div className={classes.orDivider}>
            <div className={classes.divider}>
              <svg xmlns='http://www.w3.org/2000/svg' width='148' height='1' viewBox='0 0 148 1' fill='none'>
                <rect width='147.5' height='1' fill='#D5D6D7' />
              </svg>
            </div>

            <div className={classes.or}>or</div>

            <div className={classes.divider}>
              <svg xmlns='http://www.w3.org/2000/svg' width='148' height='1' viewBox='0 0 148 1' fill='none'>
                <rect width='147.5' height='1' fill='#D5D6D7' />
              </svg>
            </div>
          </div>
        )}

        {/* <Typography variant='h5' component='h6' className={classes.hrLine}>
          <FormattedMessage {...messages.or} />
        </Typography> */}
        <Link className={classNames([classes.btnLink, classes.uaePassButton])} onClick={loginWithUAEPass}>
          <ADGMImage name={locale === 'ar' ? 'UAE_PASS_BUTTON_ARB.svg' : 'UAE_PASS_BUTTON_ENG.svg'} />
        </Link>
        <Typography variant='body1' style={{ marginTop: 12 }}>
          {keyEmptyCheck('dont_have_uae_pass_account')}
          &nbsp;
          <a href='https://uaepass.ae/' target='_blank' rel='noreferrer' className={classes.registerNow}>
            {keyEmptyCheck('register_now')}
          </a>
        </Typography>
      </div>
      <div className={classes.bottomtextholder}>
        {showEid === true && (
          <Link className={classNames(classes.linkGuest)} onClick={loginWithGuest}>
            {keyEmptyCheck('Skip_continue_as_guest')}
          </Link>
        )}
        {showErrorScreen || localStorage.getItem('uae_pass_errorCode') ? (
          <a
            target='_blank'
            href='https://www.adgm.com/contact-us/make-enquiry'
            rel='noreferrer'
            className={classes.helpLink}
          >
            {keyEmptyCheck('need_help_contact_us')}
          </a>
        ) : (
          <>
            {!isProduction && (
              <Link onClick={handleLocalToggle} variant='outlined' className={classes.iconsButton}>
                {localStorage.getItem('lang') === 'ar' ? keyEmptyCheck('english') : keyEmptyCheck('arabic')}
                <ADGMImage name='GlobeBlack.svg' />
              </Link>
            )}
          </>
        )}
      </div>
      <div />
    </Fragment>
  );
}

AuthSelector.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  subTitleLink: PropTypes.string.isRequired,
  subTitleLinkText: PropTypes.string.isRequired,
  btnPrefix: PropTypes.string.isRequired,
  redirectEID: PropTypes.string.isRequired,
  redirectUnified: PropTypes.string.isRequired,
  redirectNonUAE: PropTypes.string.isRequired,
  failure: errorProps,
  handleLogin: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

AuthSelector.defaultProps = { failure: error };

export default connect(
  state => ({
    isLoggedIn: state.authReducer.loggedIn,
    failure: state.authReducer.error,
    loading: state.authReducer.loading,
  }),
  dispatch => ({
    handleLogin: (username, password, authType) =>
      dispatch(login(authType === 'uaePass' ? username : username.replaceAll('-', ''), password, authType)),
    handleLogout: sop1Error => dispatch(logout(sop1Error)),
  }),
)(AuthSelector);
